import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/** The App JWT lives in an HttpOnly cookie; this makes the browser send it on cross-origin API calls. */
export const authCredentialsInterceptor: HttpInterceptorFn = (req, next) =>
  req.url.startsWith(environment.apiBaseUrl) ? next(req.clone({ withCredentials: true })) : next(req);
